import { combineReducers } from 'redux';
import menu from './menu';
import tokenReducer from './auth';
import userSlice from './userSlice';
import companySlice from './companySlice';

const reducers = combineReducers({
    menu,
    authToken : tokenReducer,
    user : userSlice,
    company : companySlice
  });

  export default reducers;